import { IUpdateGoodsBody, IDeleteGoodsBody } from 'redux/reducers/goods/types';
import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TGoodsApi } from './types';

export const goods: TGoodsApi = {
	updateGoods: (data: IUpdateGoodsBody) => {
		return http.put(endpoint.goods.UPDATE_GOODS, data);
	},
	deleteGoods: (data: IDeleteGoodsBody) => {
		return http.delete(endpoint.goods.DELETE_GOODS, { data });
	},
};
